export const scrollToSection = (sectionId) => {
  // Remove # if present
  const id = sectionId.replace('#', '');
  const element = document.getElementById(id);
  
  if (element) {
    // Get the navigation height to offset the scroll
    const navigation = document.querySelector('nav');
    const navHeight = navigation ? navigation.offsetHeight : 80;
    
    // Calculate the position with offset
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - navHeight - 20;
    
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

// Handle anchor links on page load
export const handleAnchorOnLoad = () => {
  if (window.location.hash) {
    setTimeout(() => {
      scrollToSection(window.location.hash);
    }, 100);
  }
};